import { CalculationCondition, CalculatorField } from '../../admin/calculator/store/types';
import styles from './Calculator.module.scss';

const { red, amber, green } = styles;

export enum LegacyCalculatorFieldType {
    CROSS_DEFAULT = 'cross default threshold amounts',
    INDEPENDENT_AMOUNTS = 'independent amounts',
    THRESHOLDS = 'thresholds',
    RATINGS_TRIGGERS = 'ratings triggers',
    NET_ASSET_VALUE_TRIGGERS = 'net asset value triggers',
    MATURITY = 'maturity',
    CREDIT_EVENT_UPON_MERGER = 'credit event upon merger',
    INTEREST_RATES = 'interest rates',
    DOCUMENTS_TO_BE_DELIVERED = 'documents to be delivered',
    DEADLINE = 'deadline',
    TIMESPAN = 'timespan',
    PERCENTAGE_COMPARATOR = 'percentage comparator'
}

export enum LegacyCalculatorInputType {
    LOGICAL_OPERATOR = 'logical operator',
    MIN_MAX = 'min max',
    BRACKET = 'bracket',
    RATING_TYPE = 'rating type',
    RATING_VALUE = 'rating value',
    RATING_CONDITIONAL = 'rating conditional',
    NEG_WATCH = 'neg watch',
    CONDITIONAL = 'conditional',
    COMPARATOR = 'comparator',
    EQUALS = 'equals',
    FALLS_BY = 'falls by',
    NUMBER = 'number',
    COMMA = 'comma',
    PERCENTAGE = 'percentage',
    CURRENCY = 'currency',
    SHAREHOLDER_EQUITY = 'shareholder equity',
    NAV = 'nav',
    HIGHEST_EVER_NAV = 'highest ever nav',
    NAV_SHAREHOLDER = 'nav per shareholder equity',
    INITIAL_NAV = 'initial nav',
    INITIAL_NAV_SHAREHOLDER = 'initial nav per shareholder equity',
    OBSERVATION_POINT = 'observation point',
    OBSERVATION_PERIOD = 'observation period',
    NOTIONAL_AMOUNT = 'notional amount',
    ADDITIONAL_TERMINATION_EVENT = 'additional termination event',
    AFFECTED_PARTY = 'affected party',
    ORDINAL_NUMBER = 'ordinal number',
    DAY_TYPE = 'day type',
    OPERATIONAL_ADMINISTRATIVE_DEFAULT = 'operation administrative defaults only',
    COB = 'close of business',
    OTHER = 'other',
    EVENT_OF_DEFAULT_ARISES = 'event of default arises',
    TERMINATION_EVENT_ARISES = 'termination event arises',
    FROM = 'from',
    OF = 'of',
    IN_THE_PRECEDING = 'in the preceding',
    NAV_OBSERVATION_PERIOD = 'nav observation period',
    NOT_APPLICABLE = 'not applicable',
    MATURITY = 'maturity',
    ORIGINAL = 'original',
    RESIDUAL = 'residual',
    MATURITY_PERIOD = 'maturity period',
    MATERIALLY_WEAKER = 'materially weaker',
    INTEREST_RATE = 'interest rate',
    DESIGNATED_MATURITY = 'designated maturity',
    OVERNIGHT = 'overnight',
    DECIMAL = 'decimal',
    SPREAD = 'spread',
    OPERATOR = 'operator',
    FLAT = 'flat',
    PARTY = 'party',
    TIME_PERIOD = 'time period',
    TRUST_PROPERTY = 'trust property',
    TRIGGER = 'trigger',
    CONJUNCTION = 'conjunction',
    DOCUMENT_TYPE = 'document type',
    DEADLINE = 'deadline',
    PERIOD = 'period',
    DATE = 'date'
}

interface CalculationConditionColors {
    [CalculationCondition.IF]: string;
    [CalculationCondition.ELSE_IF]: string;
    [CalculationCondition.ELSE]: string;
}

export const calcConditionColors: CalculationConditionColors = {
    [CalculationCondition.IF]: green,
    [CalculationCondition.ELSE_IF]: amber,
    [CalculationCondition.ELSE]: red
};

export const availableForOutput = [
    LegacyCalculatorInputType.MIN_MAX,
    LegacyCalculatorInputType.BRACKET,
    LegacyCalculatorInputType.COMMA,
    LegacyCalculatorInputType.CURRENCY,
    LegacyCalculatorInputType.NUMBER,
    LegacyCalculatorInputType.PERCENTAGE,
    LegacyCalculatorInputType.NAV,
    LegacyCalculatorInputType.INITIAL_NAV,
    LegacyCalculatorInputType.HIGHEST_EVER_NAV,
    LegacyCalculatorInputType.NAV_SHAREHOLDER,
    LegacyCalculatorInputType.INITIAL_NAV_SHAREHOLDER,
    LegacyCalculatorInputType.SHAREHOLDER_EQUITY,
    LegacyCalculatorInputType.NOTIONAL_AMOUNT,
    LegacyCalculatorInputType.AFFECTED_PARTY,
    LegacyCalculatorInputType.EVENT_OF_DEFAULT_ARISES,
    LegacyCalculatorInputType.TERMINATION_EVENT_ARISES,
    LegacyCalculatorInputType.OTHER
];

export const availableForGracePeriod = [
    LegacyCalculatorInputType.NUMBER,
    LegacyCalculatorInputType.DAY_TYPE,
    LegacyCalculatorInputType.OPERATIONAL_ADMINISTRATIVE_DEFAULT,
    LegacyCalculatorInputType.NOT_APPLICABLE
];

export const newCalculatorField = (calculationCondition: CalculationCondition | null = null): CalculatorField => ({
    calculation: [{
        index: 0,
        builder: []
    }],
    calculationCondition,
    output: [],
    gracePeriod: []
});
